// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  ICheckUserSubscriptionRequest,
  TCheckUserSubscriptionModel,
  IMappers,
  TCheckUserSubscriptionResponse,
  ICheckUserSubscriptionResponse,
  ICheckUserSubscriptionResponseError,
} from './types';

export const defaultConfig: TCheckUserSubscriptionModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'price-change-notification',
  pathApi: '/v1/check-user-subscription/',
  requestType: 'json',
} as TCheckUserSubscriptionModel;

export function createCheckUserSubscriptionModel(
  parameters: ICheckUserSubscriptionRequest,
): TCheckUserSubscriptionModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ICheckUserSubscriptionOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: ICheckUserSubscriptionRequest;
}

export async function fetchCheckUserSubscription<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ICheckUserSubscriptionOptions<TResponse200, TResponse400>): Promise<
  TCheckUserSubscriptionResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createCheckUserSubscriptionModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ICheckUserSubscriptionResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as ICheckUserSubscriptionResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TCheckUserSubscriptionResponse;
}
